export default {"src":"/_next/static/media/ln.fcd4415d.svg","height":48,"width":48};